import {link} from '../sass/base/_exports.sass';

export const CameraAddIcon = (props) => {
  const {color = link, className = '', ratio = 1} = props;

  // default dimensions
  const width = 29.891;
  const height = 22.125;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <g transform="translate(0.25 0.25)">
        <path
          style={{
            stroke: color,
            strokeWidth: 0.5,
            fillRule: 'evenodd',
            fill: color,
          }}
          d="M4.531,1.587a.8.8,0,1,0,0,1.6h3.2a.8.8,0,0,0,0-1.6Zm-1.6,3.2a2.411,2.411,0,0,0-2.4,2.4V20.812a2.414,2.414,0,0,0,2.4,2.4h19.2a.807.807,0,1,0,0-1.6H2.93a.782.782,0,0,1-.8-.8V7.186a.779.779,0,0,1,.8-.8h19.2a.786.786,0,0,1,.8.8l.014,3.994a.8.8,0,1,0,1.6,0l-.014-3.994a2.411,2.411,0,0,0-2.4-2.4Zm9.777,3.686a5.6,5.6,0,1,0,5.6,5.6A5.615,5.615,0,0,0,12.707,8.474ZM4.529,7.987a.8.8,0,1,0,.8.8.8.8,0,0,0-.8-.8Zm8.178,2.087a4,4,0,1,1-4,4A3.99,3.99,0,0,1,12.707,10.075Z"
          transform="translate(-0.529 -1.587)"
        />
        <path
          style={{
            fill: color,
            stroke: color,
            strokeWidth: 0.75,
          }}
          d="M42.251,35.874H39.475V33.118a.563.563,0,1,0-1.127,0v2.756H35.618a.563.563,0,0,0,0,1.127h2.756v2.756a.563.563,0,1,0,1.127,0V36.995h2.756a.563.563,0,1,0,0-1.127Z"
          transform="translate(-13.555 -20.936)"
        />
      </g>
    </svg>
  );
};
